const moment = require("moment");

/**
 * @author: lvieira
 * Para mais formatos: https://momentjs.com/
 * @param String date
 * @param String format
 */
const parseDate = (date, format = "DD/MM/YYYY HH:mm:ss") => {
  if (!date) {
    return "Invalid date";
  }

  try {
    let momentDate = moment(date);
    if (momentDate.isValid()) {
      if(date.toString() == '0001-01-01T00:00:00'){
        return "--";
      }
      return momentDate.format(format);
    }
    console.warn(`Invalid moment date: ${date}`);
    return date;
  } catch (e) {
    console.log(e.toString());
    return date;
  }
};

const parseDateDbFormat = (date, format = "YYYY-MM-DD") => {
  if (!date) {
    return "Invalid date";
  }

  try {
    let momentDate = moment(date);
    if (momentDate.isValid()) {
      return momentDate.format(format);
    }
    console.warn(`Invalid moment date: ${date}`);
    return date;
  } catch (e) {
    console.log(e.toString());
    return date;
  }
};
const nowWithoutTimezone = () => moment().format("YYYY-MM-DDTHH:mm:ss.SSS");

export const dateFormatter = {
  parseDate,
  nowWithoutTimezone,
  parseDateDbFormat
};
